import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import App from "./app";
import ErrorBoundary from "./components/resilience/ErrorBoundary";
import ConfigCheck from "./components/resilience/ConfigCheck";

// #11: silence developer console.log/debug noise in production builds (DDS patch
// traces, "Swap type:", "[useFormationCollection]", etc.). Real problems still
// surface via console.warn/error; devs see everything via `npm start`.
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <CssBaseline />
    {/* Root boundary: last resort. A render-time throw anywhere below used to
        unmount the whole tree and leave a white screen mid-match. */}
    <ErrorBoundary variant="root">
      <ConfigCheck>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfigCheck>
    </ErrorBoundary>
  </React.StrictMode>
);